import { useQuery, useQueryClient } from "@tanstack/react-query";

import { AccessRule, UsersListRequest } from "@/api";
import getTbiApi from "@/api/api-v1";

// SINGLE

const getUserQuery = (id: number) =>
  getTbiApi().getQueryOptions({
    queryKey: ["user-detail-raw", id],
    queryFn: async () => {
      return await getTbiApi().UsersApi.usersRetrieve({
        id: id.toString(),
      });
    },
  });

export const useUserQuery = (id: number) => useQuery(getUserQuery(id));

// LIST

const getUserListQuery = (args: UsersListRequest) =>
  getTbiApi().getQueryOptions({
    queryKey: ["user-list", args],
    queryFn: async () => {
      return await getTbiApi().UsersApi.usersList(args);
    },
  });

export const useUserListQuery = (args: UsersListRequest) => useQuery(getUserListQuery(args));

// INVALIDATION

export const useInvalidateUserQueries = () => {
  const queryClient = useQueryClient();
  return async (id: number) => {
    await queryClient.invalidateQueries({
      queryKey: getUserQuery(id).queryKey,
      refetchType: "all",
    });
    await queryClient.invalidateQueries({
      queryKey: getUserListQuery({}).queryKey.slice(0, -1),
      refetchType: "all",
    });
  };
};

export const useUpdateUserQueries = () => {
  const queryClient = useQueryClient();
  return async (user: AccessRule) => {
    queryClient.setQueryData(getUserQuery(user.id).queryKey, user);
    // FUTURE: update user list instead of invalidating
    await queryClient.invalidateQueries({
      queryKey: getUserListQuery({}).queryKey.slice(0, -1),
      refetchType: "all",
    });
  };
};
